import moduleConfig from './module-config';
import netsLogin from './nets-login';

export default angular
  .module('app.login', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsLogin', netsLogin);
